import { Button } from "@components/atoms/Button"
import { defineBlock, EditableText } from "eddev/blocks"
import { RotatingLogos } from "@components/motion/RotatingLogos"
import { Appear } from "@components/motion/Appear"
import { FeaturedCard } from "@components/atoms/FeaturedCard"

export const meta: BlockMeta = {
  title: "Landing Intro",
  tags: ["#page"],
}

export default defineBlock("content/landing-intro", (props) => {
  return (
    <>
      <div className="w-full content-sized mt-landingSpaceTop relative">
        <div className="w-full md:w-cols-8 flex flex-col">
          <Appear slide>
            <EditableText
              store="title"
              className="type-sans-2-xl-semibold md:type-sans-3-xl-semibold text-pretty"
              defaultValue="Powering the next generation of global finance."
              placeholder="Title text"
              as="p"
            />
          </Appear>
          <Appear delay={100} slide>
            <EditableText
              store="subtitle"
              className="type-serif-lg-regular md:type-serif-xl-regular mt-8 md:mt-7 text-balance"
              defaultValue="Bakkt builds next-generation digital financial infrastructure that enables institutional participation in Bitcoin, tokenization, stablecoin payments and AI driven finance. "
              placeholder="Subtitle text"
              as="p"
            />
          </Appear>
          <Appear delay={200} slide>
            <div className="mt-8 md:mt-5 flex w-full gap-7 items-center">
              {props.headingButton?.url && (
                <Button
                  variant="orange"
                  href={props.headingButton.url}
                  target={props.headingButton.target || undefined}
                  outerClassName="shrink-0"
                >
                  {props.headingButton.title || "Get Started"}
                </Button>
              )}
              <RotatingLogos
                logos={props.logos || []}
                itemsPerRotation={2}
                className="items-center justify-center gap-2 md:hidden"
              />
            </div>
          </Appear>
        </div>
      </div>
      <div className="w-full relative mt-10">
        <div
          className="w-full h-headerPattern absolute left-0 top-2 -translate-y-full md:translate-y-0 -z-10"
          style={{
            backgroundSize: "auto 100%",
            backgroundRepeat: "repeat-x",
            backgroundImage: `url("${env.themePath}/assets/images/patterns/1.svg")`,
          }}
        />
        <div className="w-full content-sized h-headerPattern items-center justify-start hidden md:flex">
          <Appear delay={150} className="w-full flex items-center justify-start gap-5 relative">
            <EditableText
              store="tickerText"
              className="type-sans-base-semibold shrink-0"
              defaultValue="Partnerships, growing."
              placeholder="Ticket text"
              as="p"
            />
            <RotatingLogos
              logos={props.logos || []}
              itemsPerRotation={4}
              className="flex w-full items-center justify-start gap-2"
            />
          </Appear>
        </div>
        {/* cards */}
        <div className="w-full bg-slate200 pb-9">
          <div className="w-full content-sized flex flex-col md:flex-row items-center justify-center gap-4">
            <FeaturedCard
              index={1}
              subtitle="To market, faster."
              title="Markets"
              body="Bakkt Institutional and Bakkt f(x) services are built for institutional-grade trading, liquidity, and regulated custody through a 50-state licensing footprint and a New York BitLicense."
              ctaText="Learn More"
              link={props.card1Link?.url || "#"}
            />
            <FeaturedCard
              index={2}
              theme="slate"
              subtitle="Frictionless. Intelligent. Auditable."
              title="Agent"
              body="Bakkt Agent combines AI-driven interfaces with compliant cross-border payments to power global money movement, savings, and yield through banking partners."
              ctaText="Learn More"
              link={props.card2Link?.url || "#"}
            />
            <FeaturedCard
              index={3}
              theme="dark"
              subtitle="Compliant. Expansive. Secure."
              title="Global"
              body="Bakkt Global is an international expansion model. It enables the leveraging of technology, products and infrastructure into new jurisdictions through minority investments."
              ctaText="Learn More"
              link={props.card3Link?.url || "#"}
            />
          </div>
        </div>
      </div>
    </>
  )
})
